import React from 'react';
import { motion } from 'framer-motion';
import { Send, MapPin, Mail, Phone } from 'lucide-react';
export function Contact() {
  return <section className="min-h-screen flex flex-col lg:flex-row border-b-2 border-navy" id="contact" data-id="element-46">
      {/* Left: Form */}
      <div className="w-full lg:w-1/2 p-6 md:p-12 lg:p-24 bg-white flex flex-col justify-center border-r-2 border-navy" data-id="element-47">
        <div className="max-w-md w-full mx-auto lg:mx-0" data-id="element-48">
          <div className="mb-12" data-id="element-49">
            <h2 className="text-4xl md:text-6xl font-bold text-navy tracking-tight mb-4" data-id="element-50">
              CONTACT
            </h2>
            <p className="font-mono text-navy/60" data-id="element-51">
              Start your transformation today.
            </p>
          </div>

          <form className="space-y-8" onSubmit={e => e.preventDefault()} data-id="element-52">
            <div className="space-y-2" data-id="element-53">
              <label className="font-mono text-xs uppercase tracking-widest text-navy/60" data-id="element-54">
                Name
              </label>
              <input type="text" className="w-full bg-transparent border-b-2 border-navy/20 py-3 text-xl text-navy focus:border-coral focus:outline-none transition-colors placeholder:text-navy/20" placeholder="John Doe" data-id="element-55" />
            </div>

            <div className="space-y-2" data-id="element-56">
              <label className="font-mono text-xs uppercase tracking-widest text-navy/60" data-id="element-57">
                Email
              </label>
              <input type="email" className="w-full bg-transparent border-b-2 border-navy/20 py-3 text-xl text-navy focus:border-coral focus:outline-none transition-colors placeholder:text-navy/20" placeholder="john@company.com" data-id="element-58" />
            </div>

            <div className="space-y-2" data-id="element-59">
              <label className="font-mono text-xs uppercase tracking-widest text-navy/60" data-id="element-60">
                Message
              </label>
              <textarea rows={4} className="w-full bg-transparent border-b-2 border-navy/20 py-3 text-xl text-navy focus:border-coral focus:outline-none transition-colors placeholder:text-navy/20 resize-none" placeholder="Tell us about your project..." data-id="element-61" />
            </div>

            <button className="group w-full bg-navy text-white py-5 font-bold tracking-widest flex items-center justify-center gap-3 hover:bg-coral transition-colors" data-id="element-62">
              SEND MESSAGE
              <Send className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-63" />
            </button>
          </form>

          <div className="mt-16 pt-8 border-t border-navy/10 space-y-4 font-mono text-sm text-navy/70" data-id="element-64">
            <div className="flex items-center gap-4" data-id="element-65">
              <MapPin className="w-5 h-5 text-coral" data-id="element-66" />
              <span data-id="element-67">ul. Marszałkowska 100, 00-026 Warszawa</span>
            </div>
            <div className="flex items-center gap-4" data-id="element-68">
              <Mail className="w-5 h-5 text-coral" data-id="element-69" />
              <span data-id="element-70">hello@coffretresor.ai</span>
            </div>
            <div className="flex items-center gap-4" data-id="element-71">
              <Phone className="w-5 h-5 text-coral" data-id="element-72" />
              <span data-id="element-73">+48 22 123 45 67</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right: Abstract Map */}
      <div className="w-full lg:w-1/2 bg-navy relative overflow-hidden min-h-[400px] lg:min-h-auto" data-id="element-74">
        {/* Stylized Vistula River */}
        <div className="absolute top-0 right-0 w-full h-full opacity-20" data-id="element-75">
          <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full" data-id="element-76">
            <path d="M0,30 C20,20 40,40 60,30 S80,10 100,20 V100 H0 Z" fill="#ffffff" data-id="element-77" />
          </svg>
        </div>

        {/* Geometric Map Elements */}
        <div className="absolute inset-0 p-12" data-id="element-78">
          <div className="grid grid-cols-6 grid-rows-6 gap-4 h-full w-full opacity-30" data-id="element-79">
            {Array.from({
            length: 36
          }).map((_, i) => <div key={i} className="border border-white/20 rounded-sm" data-id="element-80" />)}
          </div>
        </div>

        {/* Location Marker */}
        <motion.div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" initial={{
        scale: 0
      }} whileInView={{
        scale: 1
      }} transition={{
        type: 'spring',
        bounce: 0.5
      }} data-id="element-81">
          <div className="relative" data-id="element-82">
            <div className="w-8 h-8 bg-coral rotate-45" data-id="element-83" />
            <div className="absolute -inset-4 border-2 border-white rotate-45 animate-pulse" data-id="element-84" />
            <div className="absolute top-12 left-1/2 -translate-x-1/2 whitespace-nowrap bg-white text-navy px-3 py-1 font-mono text-xs font-bold" data-id="element-85">
              WARSZAWA HQ
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}